import { forwardRef } from 'react';
import cx from 'classnames';
import {
  CircularProgress,
  IconButton as MuiIconButton,
  alpha,
  makeStyles,
} from '@material-ui/core';

import { palette } from '@material-ui/system';

const useStyles = makeStyles((theme) => ({
  root: (props) => {
    const { size, variant, color, hoverColor, disabled } = props;

    const s = (() => {
      if (size === 'small') {
        return 32;
      }
      if (size === 'large') {
        return 48;
      }
      return 40;
    })();

    const baseColor = (() => {
      if (variant === 'contained') {
        return alpha(theme.palette.colors.grey900, 0.05);
      }
    })();

    const hoverBaseColor = (() => {
      if (variant === 'contained') {
        return alpha(theme.palette.colors.grey900, 0.1);
      }
    })();

    const textColor = (() => {
      if (disabled) {
        return theme.palette.colors.grey300;
      }
      if (theme.palette[color]?.main) {
        return theme.palette[color].main;
      }
      return palette({ theme, color }).color;
    })();

    const hoverTextColor = (() => {
      if (theme.palette[hoverColor]?.dark) {
        return theme.palette[hoverColor].dark;
      }
      return palette({ theme, color: hoverColor }).color;
    })();

    return {
      filter: `grayscale(${disabled ? 1 : 0})`,
      opacity: disabled ? 0.6 : 1,
      color: textColor,
      borderRadius: theme.spacing(0.5),
      width: s,
      minWidth: s,
      maxWidth: s,
      height: s,
      maxHeight: s,
      minHeight: s,
      overflow: 'hidden',
      backgroundColor: baseColor,

      '&:hover': {
        backgroundColor: hoverBaseColor,
        color: hoverTextColor,
      },
    };
  },
  loading: {
    opacity: 0.5,
    pointerEvents: 'none',
    transform: 'scale(0.9)',
  },
  spinner: {
    position: 'absolute',
    left: 0,
    top: 0,
    width: '100%',
    height: '100%',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },
}));

const IconButton = forwardRef((props, ref) => {
  const {
    size = 'medium',
    variant = 'transparent',
    children,
    className,
    color = 'primary',
    hoverColor,
    disabled,
    loading,
    ...rest
  } = props;

  const classes = useStyles({
    size,
    variant,
    color,
    disabled,
    hoverColor,
  });

  const rootClasses = cx(classes.root, loading && classes.loading, className);

  return (
    <MuiIconButton
      ref={ref}
      {...rest}
      disabled={disabled}
      className={rootClasses}
    >
      {children}

      {loading && (
        <div className={classes.spinner}>
          <CircularProgress size={20} color="inherit" />
        </div>
      )}
    </MuiIconButton>
  );
});

export default IconButton;
